var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('markdown-field-view',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.richViewer || _vm.content),expression:"richViewer || content"}],ref:"content"})}
var staticRenderFns = []

export { render, staticRenderFns }